import { render, staticRenderFns } from "./PricingCommercialBlockPrimaryLayer.vue?vue&type=template&id=50922f80"
import script from "./PricingCommercialBlockPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingCommercialBlockPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports